<template>
  <div>
    <!-- 일별검색 -->
    <vs-tabs :value="selectedTab">
      <vs-tab :label="tabs[0].label">
        <div>
          <search-nav @handleSearch="handleSearch">
            <search-nav-item-date :label="$t('search.대상기간')" v-model="nav.date" type="single" />
            <search-nav-item-project label="사업장명" v-model="nav.projectId" />
          </search-nav>

          <vs-row class="mb-4">
            <vs-col class="flex" vs-justify="flex-end">
              <vs-button color="secondary" type="border" @click="excelDownWithHtml('safety_staff_management_daily')">{{$t('button.Excel 다운로드')}}</vs-button>
            </vs-col>
          </vs-row>

          <vs-row class="border">
            <vs-col>
              <div class="border-top border-left border-right table-display-title">
                <span class="title table-center"></span>
                <span class="title table-center border-left">{{$t('content.safety.staff.managerment.table.금일 합계')}}</span>
                <span class="title table-center border-left">{{$t('content.safety.staff.managerment.table.금일 비율')}}</span>
                <span class="title table-center border-left">{{$t('content.safety.staff.managerment.table.월 합계')}}</span>
              </div>
            </vs-col>
          </vs-row>

          <vs-row class="border">
            <vs-col>
              <div class="border-top border-left border-right table-display-title">
                <span class="title table-center">{{$t('content.safety.staff.managerment.table.사업장명')}}</span>
                <div class="table-display-sub-5">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.전체')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>

                <div class="table-display-sub-4">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>

                <div class="table-display-sub-5">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.전체')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>

              </div>
            </vs-col>
          </vs-row>

          <vs-row class="">
            <vs-col class="border-bottom">
              <div class="border-top border-left border-right table-display-title"
                   :data="tr" :key="indextr" v-for="(tr, indextr) in table.listDaily">

                <span class="title table-center">{{ tr.type }}</span>
                <div class="table-display-sub-5 table-content">
                  <span class="title table-center border-left w-full">{{ tr.day_sum_all }}</span>
                  <span class="title table-center border-left w-full">{{ tr.day_sum_tbm }}</span>
                  <span class="title table-center border-left w-full">{{ tr.day_sum_female }}</span>
                  <span class="title table-center border-left w-full">{{ tr.day_sum_oldage }}</span>
                  <span class="title table-center border-left w-full">{{ tr.day_sum_foreign }}</span>
                </div>

                <div class="table-display-sub-4 table-content">
                  <span class="title table-center border-left w-full">{{
                      getRatio(tr.day_sum_tbm, tr.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(tr.day_sum_female, tr.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(tr.day_sum_oldage, tr.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(tr.day_sum_foreign, tr.day_sum_all)
                    }}%</span>
                </div>

                <div class="table-display-sub-5 table-content">
                  <span class="title table-center border-left w-full">{{ tr.month_sum_all }}</span>
                  <span class="title table-center border-left w-full">{{ tr.month_sum_tbm }}</span>
                  <span class="title table-center border-left w-full">{{ tr.month_sum_female }}</span>
                  <span class="title table-center border-left w-full">{{ tr.month_sum_oldage }}</span>
                  <span class="title table-center border-left w-full">{{ tr.month_sum_foreign }}</span>
                </div>
              </div>
            </vs-col>
          </vs-row>


          <!-- PJI -->
          <vs-row class="border mt-8">
            <vs-col>
              <div class="border table-display-sum">
                <span class="title table-center" style="grid-row: 1/4; grid-column: 1; ">{{$t('content.safety.staff.managerment.table.PJI')}}</span>
                <span class="title table-center border-left border-bottom"
                      style="grid-row: 1; grid-column: 2;">{{$t('content.safety.staff.managerment.table.금일 합계')}}</span>
                <span class="title table-center border-left border-bottom"
                      style="grid-row: 1; grid-column: 3;">{{$t('content.safety.staff.managerment.table.금일 비율')}}</span>
                <span class="title table-center border-left border-bottom"
                      style="grid-row: 1; grid-column: 4;">{{$t('content.safety.staff.managerment.table.월 합계')}}</span>


                <div class="table-display-sub-5 border-bottom" style="grid-row: 2; grid-column: 2;">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.전체')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>

                <div class="table-display-sub-4 border-bottom" style="grid-row: 2; grid-column: 3;">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>

                <div class="table-display-sub-5 border-bottom" style="grid-row: 2; grid-column: 4;">
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.전체')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.TBM')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.여성')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.고령')}}</span>
                  <span class="title table-center border-left w-full">{{$t('content.safety.staff.managerment.table.외국인')}}</span>
                </div>


                <div class="table-display-sub-5 table-content" style="grid-row: 3; grid-column: 2;">
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.day_sum_all }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.day_sum_tbm }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.day_sum_female }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.day_sum_oldage }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.day_sum_foreign }}</span>
                </div>

                <div class="table-display-sub-4 table-content" style="grid-row: 3; grid-column: 3;">
                  <span class="title table-center border-left w-full">{{
                      getRatio(this.table.sumDaily.day_sum_tbm, this.table.sumDaily.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(this.table.sumDaily.day_sum_female, this.table.sumDaily.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(this.table.sumDaily.day_sum_oldage, this.table.sumDaily.day_sum_all)
                    }}%</span>
                  <span class="title table-center border-left w-full">{{
                      getRatio(this.table.sumDaily.day_sum_foreign, this.table.sumDaily.day_sum_all)
                    }}%</span>
                </div>

                <div class="table-display-sub-5 table-content" style="grid-row: 3; grid-column: 4;">
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.month_sum_all }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.month_sum_tbm }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.month_sum_female }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.month_sum_oldage }}</span>
                  <span class="title table-center border-left w-full">{{ this.table.sumDaily.month_sum_foreign }}</span>
                </div>

              </div>
            </vs-col>
          </vs-row>


        </div>
      </vs-tab>

      <!-- 월별검색 -->
      <vs-tab :label="tabs[1].label">
        <div>

          <!--  상단 검색바-->
          <search-nav @handleSearch="handleSearchMonth">
            <search-nav-item-select :label="$t('search.대상기간')" v-model="nav.year" :list="nav.yearList" />년
            <search-nav-item-select v-model="nav.month" :list="nav.monthList" />
            <span class="mr-6">월</span>
            <search-nav-item-project :label="$t('search.사업장명')" v-model="nav.projectId" />
          </search-nav>


          <vs-row class="mb-4">
            <vs-col class="flex" vs-justify="flex-end">
              <vs-button color="secondary" type="border" @click="excelDownWithHtml('safety_staff_management_month')">{{$t('button.Excel 다운로드')}}</vs-button>
            </vs-col>
          </vs-row>


          <vs-row class="">
            <vs-col class="border-top border-left border-right" style="overflow-x:auto;">
              <div class="table-display-month">
                <span class="title table-center" style="min-width:120px;">{{$t('content.safety.staff.managerment.table.사업자 번호')}}</span>
                <span class="title table-center border-left" style="min-width:100px;">{{$t('content.safety.staff.managerment.table.파트너사')}}</span>
                <span :key="indextr" v-for="(tr, indextr) in this.numOflistMontly"
                      class="title table-center border-left">{{ indextr + 1 }}</span>
              </div>

              <div class="table-display-month">
                <span class="title table-center" style="min-width:120px;"></span>
                <span class="title table-center border-left" style="min-width:100px;">{{$t('content.safety.staff.managerment.table.전체')}}</span>
                <span :key="indextr" v-for="(tr, indextr) in this.table.sumMontly"
                      class="title table-center border-left table-content">{{tr}}</span>
              </div>

              <div
                v-for="(company, comIndex) in table.listMontlyWithCompany"
                :key="comIndex"
                class="table-display-month">
                <span class="title table-center" style="min-width:120px;">{{ company.com_number }}</span>
                <span class="title table-center border-left" style="min-width:100px;">{{ company.com_name }}</span>
                <span :key="valIndex" v-for="(value, valIndex) in company.values"
                      class="title table-center border-left table-content">{{ value }}</span>
              </div>
            </vs-col>
          </vs-row>
        </div>
      </vs-tab>
    </vs-tabs>

    <table id="safety_staff_management_daily" style="display: none;">
      <tr>
        <th></th>
        <th colspan="5" align="center">{{$t('content.safety.staff.managerment.table.금일 합계')}}</th>
        <th colspan="4" align="center">{{$t('content.safety.staff.managerment.table.금일 비율')}}</th>
        <th colspan="5" align="center">{{$t('content.safety.staff.managerment.table.월 합계')}}</th>
      </tr>
      <tr>
        <th>{{$t('content.safety.staff.managerment.table.사업장명')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.전체')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.전체')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
      </tr>
      <tr :key="indextr" v-for="(tr, indextr) in table.listDaily">
        <td>{{ tr.type }}</td>
        <td>{{ tr.day_sum_all }}</td>
        <td>{{ tr.day_sum_tbm }}</td>
        <td>{{ tr.day_sum_female }}</td>
        <td>{{ tr.day_sum_oldage }}</td>
        <td>{{ tr.day_sum_foreign }}</td>
        <td>{{getRatio(tr.day_sum_tbm, tr.day_sum_all)}}%</td>
        <td>{{getRatio(tr.day_sum_female, tr.day_sum_all)}}%</td>
        <td>{{getRatio(tr.day_sum_oldage, tr.day_sum_all)}}%</td>
        <td>{{getRatio(tr.day_sum_foreign, tr.day_sum_all)}}%</td>
        <td>{{ tr.month_sum_all }}</td>
        <td>{{ tr.month_sum_tbm }}</td>
        <td>{{ tr.month_sum_female }}</td>
        <td>{{ tr.month_sum_oldage }}</td>
        <td>{{ tr.month_sum_foreign }}</td>
      </tr>

      <tr></tr>
      <tr></tr>

      <tr>
        <th rowspan="3">{{$t('content.safety.staff.managerment.table.PJI')}}</th>
        <th colspan="5" align="center">{{$t('content.safety.staff.managerment.table.금일 합계')}}</th>
        <th colspan="4" align="center">{{$t('content.safety.staff.managerment.table.금일 비율')}}</th>
        <th colspan="5" align="center">{{$t('content.safety.staff.managerment.table.월 합계')}}</th>
      </tr>
      <tr>
        <th>{{$t('content.safety.staff.managerment.table.전체')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.전체')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.TBM')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.여성')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.고령')}}</th>
        <th>{{$t('content.safety.staff.managerment.table.외국인')}}</th>
      </tr>

      <tr>
        <td>{{ this.table.sumDaily.day_sum_all }}</td>
        <td>{{ this.table.sumDaily.day_sum_tbm }}</td>
        <td>{{ this.table.sumDaily.day_sum_female }}</td>
        <td>{{ this.table.sumDaily.day_sum_oldage }}</td>
        <td>{{ this.table.sumDaily.day_sum_foreign }}</td>
        <td>{{ getRatio(this.table.sumDaily.day_sum_tbm, this.table.sumDaily.day_sum_all) }}%</td>
        <td>{{ getRatio(this.table.sumDaily.day_sum_female, this.table.sumDaily.day_sum_all) }}%</td>
        <td>{{ getRatio(this.table.sumDaily.day_sum_oldage, this.table.sumDaily.day_sum_all) }}%</td>
        <td>{{ getRatio(this.table.sumDaily.day_sum_foreign, this.table.sumDaily.day_sum_all) }}%</td>
        <td>{{ this.table.sumDaily.month_sum_all }}</td>
        <td>{{ this.table.sumDaily.month_sum_tbm }}</td>
        <td>{{ this.table.sumDaily.month_sum_female }}</td>
        <td>{{ this.table.sumDaily.month_sum_oldage }}</td>
        <td>{{ this.table.sumDaily.month_sum_foreign }}</td>
      </tr>

    </table>
    <table id="safety_staff_management_month" style="display: none;">
      <tr>
        <td>{{$t('content.safety.staff.managerment.table.사업자 번호')}}</td>
        <td>{{$t('content.safety.staff.managerment.table.파트너사')}}</td>
        <td :key="indextr" v-for="(tr, indextr) in this.numOflistMontly">{{ indextr + 1 }}</td>
      </tr>

      <tr>
        <td></td>
        <td>{{$t('content.safety.staff.managerment.table.전체')}}</td>
        <td :key="indextr" v-for="(tr, indextr) in this.table.sumMontly">{{ tr }}</td>
      </tr>

      <tr v-for="(company, comIndex) in table.listMontlyWithCompany"
          :key="comIndex">
        <td>{{ company.com_number }}</td>
        <td>{{ company.com_name }}</td>
        <td :key="valIndex" v-for="(value, valIndex) in company.values">{{ value }}</td>
      </tr>
    </table>
  </div>
</template>

<script>
import SearchNavItemKeyword from '@/components/nav/SearchNavItemKeyword'
import SearchNavItemDate from '@/components/nav/SearchNavItemDate'
import SearchNav from '@/components/nav/SearchNav'
import SearchNavItemProject from '@/components/nav/SearchNavItemProject'
import XLSX from 'xlsx'
import SearchNavItemSelect from '@/components/nav/SearchNavItemSelect'

export default {
  name: 'SafetyStaffManagerment',
  components: {
    SearchNavItemSelect,
    SearchNavItemProject,
    SearchNav,
    SearchNavItemDate,
    SearchNavItemKeyword
  },
  data () {
    return {
      // 검색 네비게이션
      nav: {
        projectId: '',
        date: ['', ''],
        keyword: '',
        year: new Date().getFullYear(),
        yearList:[],
        month: '',
        monthList:[
          {text:'전체', value:''},
          {text:'1', value:'1'},
          {text:'2', value:'2'},
          {text:'3', value:'3'},
          {text:'4', value:'4'},
          {text:'5', value:'5'},
          {text:'6', value:'6'},
          {text:'7', value:'7'},
          {text:'8', value:'8'},
          {text:'9', value:'9'},
          {text:'10', value:'10'},
          {text:'11', value:'11'},
          {text:'12', value:'12'}
        ],
      },
      rootPath: '', // 프로젝트의 rootPath
      selectedTab: -1,
      tabs: [
        {
          label: this.$t('content.safety.staff.managerment.tab.일별검색'),
          key: 'daily',
          create: false,
          update: false
        },
        {
          label: this.$t('content.safety.staff.managerment.tab.월별검색'),
          key: 'monthly',
          create: false,
          update: false
        }
      ],
      table: {
        sumDaily: {
          day_sum_all: 0,
          day_sum_tbm: 0,
          day_sum_female: 0,
          day_sum_oldage: 0,
          day_sum_foreign: 0,
          month_sum_all: 0,
          month_sum_tbm: 0,
          month_sum_female: 0,
          month_sum_oldage: 0,
          month_sum_foreign: 0
        },
        listDaily: [
          {
            type: '건축주택',
            day_sum_all: 0,
            day_sum_tbm: 0,
            day_sum_female: 0,
            day_sum_oldage: 0,
            day_sum_foreign: 0,
            month_sum_all: 0,
            month_sum_tbm: 0,
            month_sum_female: 0,
            month_sum_oldage: 0,
            month_sum_foreign: 0
          },
          {
            type: 'Infra',
            day_sum_all: 0,
            day_sum_tbm: 0,
            day_sum_female: 0,
            day_sum_oldage: 0,
            day_sum_foreign: 0,
            month_sum_all: 0,
            month_sum_tbm: 0,
            month_sum_female: 0,
            month_sum_oldage: 0,
            month_sum_foreign: 0
          },
          {
            type: '플랜트',
            day_sum_all: 0,
            day_sum_tbm: 0,
            day_sum_female: 0,
            day_sum_oldage: 0,
            day_sum_foreign: 0,
            month_sum_all: 0,
            month_sum_tbm: 0,
            month_sum_female: 0,
            month_sum_oldage: 0,
            month_sum_foreign: 0
          },
          {
            type: '에너지',
            day_sum_all: 0,
            day_sum_tbm: 0,
            day_sum_female: 0,
            day_sum_oldage: 0,
            day_sum_foreign: 0,
            month_sum_all: 0,
            month_sum_tbm: 0,
            month_sum_female: 0,
            month_sum_oldage: 0,
            month_sum_foreign: 0
          },
          {
            type: '전체합계',
            day_sum_all: 0,
            day_sum_tbm: 0,
            day_sum_female: 0,
            day_sum_oldage: 0,
            day_sum_foreign: 0,
            month_sum_all: 0,
            month_sum_tbm: 0,
            month_sum_female: 0,
            month_sum_oldage: 0,
            month_sum_foreign: 0
          }
        ],
        sumMontly: [],
        listMontlyWithCompany: [],
        perPage: 1,
        keyword: ''
      },
      numOflistMontly: 31,
      list: [],
      listAll: []
    }
  },

  async created () {
    let nowYear = new Date().getFullYear()
    for (let i = 0; i < 50; i++) {
      this.nav.yearList.push({text:`${nowYear}`,  value:nowYear})
      nowYear--
    }

    this.nav.date = [new Date().format('yyyy-MM-dd'), '']
    await this.loadPostList()
    await this.loadPostListMonth()
  },
  methods: {
    // 사업장 개요 불러오기
    async loadPostList () {
      this.table.sumDaily = {
        day_sum_all: 0,
        day_sum_tbm: 0,
        day_sum_female: 0,
        day_sum_oldage: 0,
        day_sum_foreign: 0,
        month_sum_all: 0,
        month_sum_tbm: 0,
        month_sum_female: 0,
        month_sum_oldage: 0,
        month_sum_foreign: 0
      }
      for (const daily of this.table.listDaily) {
        daily.day_sum_all = 0
        daily.day_sum_tbm = 0
        daily.day_sum_female = 0
        daily.day_sum_oldage = 0
        daily.day_sum_foreign = 0
        daily.month_sum_all = 0
        daily.month_sum_tbm = 0
        daily.month_sum_female = 0
        daily.month_sum_oldage = 0
        daily.month_sum_foreign = 0
      }

      const projectId = this.nav.projectId
      const boardId = 21 // manpower
      const page = 1
      const perPage = 100000
      const dateTarget = 'created_at'
      let dateBegin = this.nav.date[0]
      let dateEnd = this.nav.date[0]

      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId,
        boardId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd
      })
      this.list = this.$store.state.board.postListInfo.data

      for (const item of this.list) {
        const preview = this.getPreview(item)
        let all = 0, tbm = 0, female = 0, oldage = 0, foreign = 0
        all = Number(preview.num_of_all)
        tbm = Number(preview.num_of_tbm)
        female = Number(preview.num_of_female)
        oldage = Number(preview.num_of_oldage)
        foreign = Number(preview.num_of_foreign)

        if (Number(preview.type) > 0) {
          this.table.listDaily[Number(preview.type) - 1].day_sum_all += all
          this.table.listDaily[Number(preview.type) - 1].day_sum_tbm += tbm
          this.table.listDaily[Number(preview.type) - 1].day_sum_female += female
          this.table.listDaily[Number(preview.type) - 1].day_sum_oldage += oldage
          this.table.listDaily[Number(preview.type) - 1].day_sum_foreign += foreign
        }
      }


      dateEnd = this.getLastDateWithSearchDate(dateBegin)
      dateBegin = this.getFirstDateWithSearchDate(dateBegin)
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId,
        boardId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd
      })
      this.listAll = this.$store.state.board.postListInfo.data

      for (const item of this.listAll) {
        const preview = this.getPreview(item)
        let all = 0, tbm = 0, female = 0, oldage = 0, foreign = 0
        all = Number(preview.num_of_all)
        tbm = Number(preview.num_of_tbm)
        female = Number(preview.num_of_female)
        oldage = Number(preview.num_of_oldage)
        foreign = Number(preview.num_of_foreign)

        if (Number(preview.type) > 0) {
          this.table.listDaily[Number(preview.type) - 1].month_sum_all += all
          this.table.listDaily[Number(preview.type) - 1].month_sum_tbm += tbm
          this.table.listDaily[Number(preview.type) - 1].month_sum_female += female
          this.table.listDaily[Number(preview.type) - 1].month_sum_oldage += oldage
          this.table.listDaily[Number(preview.type) - 1].month_sum_foreign += foreign
        }
      }

      for (const daily of this.table.listDaily) {
        this.table.sumDaily.day_sum_all += daily.day_sum_all
        this.table.sumDaily.day_sum_tbm += daily.day_sum_tbm
        this.table.sumDaily.day_sum_female += daily.day_sum_female
        this.table.sumDaily.day_sum_oldage += daily.day_sum_oldage
        this.table.sumDaily.day_sum_foreign += daily.day_sum_foreign

        this.table.sumDaily.month_sum_all += daily.month_sum_all
        this.table.sumDaily.month_sum_tbm += daily.month_sum_tbm
        this.table.sumDaily.month_sum_female += daily.month_sum_female
        this.table.sumDaily.month_sum_oldage += daily.month_sum_oldage
        this.table.sumDaily.month_sum_foreign += daily.month_sum_foreign
      }
    },
    // 사업장 개요 불러오기
    async loadPostListMonth () {
      this.table.listMontlyWithCompany = []
      this.table.sumMontly = []

      const projectId = this.nav.projectId
      const boardId = 21 // manpower
      const page = 1
      const perPage = 100000

      const year = this.nav.year
      const month = this.nav.month
      const dateTarget = 'created_at'
      const dateBegin = this.getFirstDateWithSearchDateYearMonth(year, month)
      const dateEnd = this.getLastDateWithSearchDateYearMonth(year, month)
      this.numOflistMontly = Number(dateEnd.substr(8))
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId,
        boardId,
        page,
        perPage,
        dateTarget,
        dateBegin,
        dateEnd
      })
      this.listAll = this.$store.state.board.postListInfo.data

      const _temp_values = []//{ com_name:'', values:[] }
      for (const item of this.listAll) {
        const preview = this.getPreview(item)
        const created_at = item.created_at.substr(0, 11)
        const created_day = Number(created_at.substr(8))

        if (_temp_values.length === 0) {
          // 첫 번째 파트너사 등록
          const index = 0
          if (preview.com_number) {
            _temp_values[index] = {
              com_name: preview.com_name,
              com_number: preview.com_number,
              values: []
            }
            for (let d = 1; d <= Number(dateEnd.substr(8)); d++) {
              _temp_values[index].values[d - 1] = 0
            }
            _temp_values[index].values[created_day - 1] = Number(preview.num_of_all)
          }
        } else if (preview.com_number) {

          // 등록된 파트너사와 비교
          let hasCompany = false
          for (let i = 0; i < _temp_values.length; i++) {
            if (_temp_values[i].com_number === preview.com_number) {
              const index = i
              _temp_values[index].values[created_day - 1] += Number(preview.num_of_all)
              hasCompany = true
            }
          }

          // 새로운 파트너사 일 경우 파트너사 추가
          if (hasCompany === false) {
            const index = _temp_values.length
            if (preview.com_number) {
              _temp_values[index] = {
                com_name: preview.com_name,
                com_number: preview.com_number,
                values: []
              }
              for (let d = 1; d <= Number(dateEnd.substr(8)); d++) {
                _temp_values[index].values[d - 1] = 0
              }
              _temp_values[index].values[created_day - 1] = Number(preview.num_of_all)
            }
          }

        }
      }

      this.table.listMontlyWithCompany = _temp_values

      for (const com of this.table.listMontlyWithCompany) {
        for (let i = 0; i < com.values.length; i++) {
          if (!this.table.sumMontly[i]) {
            this.table.sumMontly[i] = 0
          }
          this.table.sumMontly[i] += com.values[i]
        }
      }

    },

    getRatio (value, all) {
      if (all > 0) {
        const dig = 100 // 소수점 두자리까지
        return Math.floor(value * 100 * dig / all) / dig
      } else {
        return 0.00
      }
    },

    getPreview (data) {
      if (data.preview) {
        const preview = JSON.parse(data.preview)
        return preview
      } else {
        return {
          field_name: '',
          type: '',
          com_name: '',
          writer: '',
          num_of_all: '',
          num_of_tbm: '',
          num_of_female: '',
          num_of_oldage: '',
          num_of_foreign: ''
        }
      }
    },

    getTypeName (type) {
      if (type === '0') return '부문없음'
      else if (type === '1') return '건축주택'
      else if (type === '2') return '인프라'
      else if (type === '3') return '하이테크'
      else if (type === '4') return '에너지'
    },

    getFirstDateWithSearchDate (searchDate) {
      const date = new Date(searchDate)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      month = (month > 9) ? month : `0${month}`
      return new Date(`${year}-${month}-01`).format('yyyy-MM-dd')
    },

    getLastDateWithSearchDate (searchDate) {
      const date = new Date(searchDate)
      const year = date.getFullYear()
      let month = date.getMonth() + 1
      month = (month > 9) ? month : `0${month}`
      let last = new Date(year, month)
      last = new Date(last - 1)
      return new Date(`${year}-${month}-${last.getDate()}`).format('yyyy-MM-dd')
    },

    getFirstDateWithSearchDateYearMonth (year, month) {
      if (year > 0 && month > 0) {
        return new Date(`${year}-${month}-01`).format('yyyy-MM-dd')
      } else if (year > 0 && month === '') {
        return new Date(`${year}-01-01`).format('yyyy-MM-dd')
      }

      return ''
    },

    getLastDateWithSearchDateYearMonth (year, month) {
      if (year > 0 && month > 0) {
        let last = new Date(year, month)
        last = new Date(last - 1)
        return new Date(`${year}-${month}-${last.getDate()}`).format('yyyy-MM-dd')
      } else if (year > 0 && month === '') {
        return new Date(`${year}-12-31`).format('yyyy-MM-dd')
      }

      return ''
    },


    handleSearch () {
      this.loadPostList()
    },

    handleSearchMonth () {
      this.loadPostListMonth()
    },

    excelDownWithHtml (tableName) {
      const wb = XLSX.utils.table_to_book(document.getElementById(tableName), {sheet:'인원투입 현황', raw:true})
      XLSX.writeFile(wb, ('인원투입 현황.xlsx'))
    }
  }
}
</script>

<style scoped>

.table-display-title {
  display: grid;
  grid-template-rows: minmax(52px, 100%);
  grid-template-columns: 2fr repeat(3, minmax(0, 5fr));
}

.table-display-sub-5 {
  display: grid;
  grid-template-rows: minmax(52px, 100%);
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.table-display-sub-4 {
  display: grid;
  grid-template-rows: minmax(52px, 100%);
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.table-display-sum {
  display: grid;
  grid-template-rows: repeat(3, minmax(52px, 100%));
  grid-template-columns: 2fr repeat(3, minmax(0, 5fr));
}

.table-display-month {
  display: flex;
  height: 53px;
  grid-template-rows: minmax(52px, 100%);
}

.table-display-month span {
  flex: 1;
  min-width: 40px;

  border-bottom: 1px solid #cdcdcd;
}

.table-content {
  background-color: white;
}

.table-center {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
</style>
